<template>
  <div
    class="hint-message"
    :class="{
      'hint-message--no-icon': !showIcon && !$slots.icon,
      'hint-message--no-cta': !ctaLabel && !$slots.cta,
      'hint-message--center-icon': centerIcon,
    }"
  >
    <div v-if="showIcon || $slots.icon" class="hint-message__icon">
      <slot name="icon">
        <icon-wishlist-fill />
      </slot>
    </div>

    <div class="hint-message__container">
      <div class="hint-message__content">
        <p
          v-if="title"
          class="text-mobile-paragraph-s-bold text-desktop-paragraph-s-bold"
          v-text="title"
        />

        <div
          class="text-mobile-paragraph-s-regular text-desktop-paragraph-s-regular"
          v-html="content"
        />
      </div>

      <div v-if="ctaLabel || $slots.cta" class="hint-message__cta">
        <slot name="cta">
          <btn
            :label="ctaLabel"
            modifiers="secondary center"
            size="medium-large"
          />
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Vue: Hint message (hint-message)
 * -----------------------------------------------------------------------------
 * Neutral message box with icon and CTA.
 *
 * @param {Boolean} [centerIcon] - Vertically center icon.
 * @param {String} content - Message content.
 * @param {String} [ctaLabel] - Button label, or provide button to slot.
 * @param {Boolean} [showIcon] - Show icon, or use slot to customise.
 * @param {String} [title] - Message title.
 *
 */
import Btn from '~global/btn/btn';

import IconWishlistFill from '~icons/general/wishlist-fill.svg';

export default {
  name: 'HintMessage',

  components: {
    Btn,
    IconWishlistFill,
  },

  props: {
    centerIcon: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
      required: true,
    },
    ctaLabel: {
      type: String,
      default: '',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
@import './hint-message';
</style>
